import ConsultButton from "@/components/ConsultButton";
import { Box, Stack } from "@chakra-ui/react";
import {
  getCdnImageSrc,
  Image,
  VStack,
  responsive,
  colors,
  NextLink,
} from "goi_common";
import { ReactNode } from "react";

export default function BenefitSecondSection() {
  return (
    <VStack width="100%" alignItems="center" background={colors.black}>
      <VStack
        maxWidth={`${1200}px`}
        gap="28px"
        css={responsive({
          padding: {
            base: "64px 24px",
            lg: "120px 24px",
          },
        })}
      >
        <VStack width="100%" alignItems="center" gap="16px">
          <Box
            className="gray400 subtitle_21_b lg_head_28_b"
            id="home-service"
            scrollMarginTop={100}
          >
            상조용품 제작
          </Box>
          <Box className="white head_28_b lg_head_42_b" textAlign="center">
            상조용품 제작, <br className="lg_over_hidden" />
            무료 제작혜택 받기
          </Box>
          <Box
            className="gray300 subtitle_16_m lg_head_24_m"
            textAlign="center"
          >
            최소 30박스부터 맞춤형 제작이 가능해요
            <br />
            기업상조 도입 혜택 받고, 무료로 제작하세요
          </Box>

          <VStack css={{ marginBottom: "20px" }}>
            <ConsultButton text="견적 받아보기" />

            <NextLink
              href="/disposal/"
              css={responsive({
                background: colors.gray800,
                color: colors.white,
                padding: { base: "10px 44px", lg: "14px 52px" },
                borderRadius: "10px",
                fontSize: "21px",
                fontWeight: "bold",
              })}
            >
              자세히 알아보기
            </NextLink>
          </VStack>
        </VStack>
        <BenefitItem
          num={1}
          title={"업계 최저가, 박스당 6만원부터 제작"}
          description={
            <>
              박스 제작 가격도 저렴하지만,
              <br />
              상조서비스와 함께 계약해서
              <br />
              장례서비스 지원받을 때마다 혜택으로 돌려받으세요.
            </>
          }
          imageSize={{
            width: { base: "100%", lg: "45%" },
            height: { base: "100%", lg: "300px" },
          }}
        />
        <BenefitItem
          num={2}
          title={"30박스부터 맞춤제작"}
          description={
            <>
              임직원 300명 이상 기업은 2년 평균 사용률 10%에 맞춰
              <br />
              소량으로 제작도 가능해요.
            </>
          }
          imageSize={{
            width: { base: "100%", lg: "50%" },
            height: { base: "100%", lg: "300px" },
          }}
        />
        <BenefitItem
          num={3}
          title={"편리한 발주, 전국 당일 배송 가능"}
          description={
            <>
              전화 한 통으로 발주하고
              <br />
              전국 어디든 당일배송 받으세요.
            </>
          }
          imageSize={{
            width: { base: "100%", lg: "50%" },
            height: { base: "100%", lg: "300px" },
          }}
        />
      </VStack>
    </VStack>
  );
}

function BenefitItem({
  num,
  title,
  imageSize,
  description,
}: {
  num: number;
  title: string;
  imageSize: {
    width: { base: string; lg: string };
    height: { base: string; lg: string };
  };
  description: ReactNode;
}) {
  return (
    <Stack
      gap="16px"
      justifyContent="space-between"
      css={responsive({
        flexDirection: { base: "column", lg: "row" },
        padding: { base: "24px", lg: "52px 48px" },
        borderRadius: "16px",
      })}
      background={colors.gray100}
      overflow="hidden"
    >
      <VStack
        justifyContent="center"
        css={responsive({
          width: { base: "100%", lg: "50%" },
        })}
      >
        <Box className="orange650 subtitle_18_b lg_head_24_b">0{num}</Box>
        <Box
          className="gray900 head_24_b lg_head_32_b"
          css={responsive({
            whiteSpace: "pre-line",
            padding: { base: "8px 0 10px", lg: "16px 0 20px" },
          })}
        >
          {title}
        </Box>

        <Box
          className="gray600 body_14_r lg_subtitle_21_r"
          css={{ wordBreak: "keep-all" }}
        >
          {description}
        </Box>
      </VStack>
      <VStack borderRadius="16px" css={responsive(imageSize)}>
        <Image
          src={getCdnImageSrc(`b2b/home/service-${num}.png`)}
          width="100%"
          height="auto"
          alt=""
        />
      </VStack>
    </Stack>
  );
}
